import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAuthUserSelector } from "../../../store/selectors/authSelector";
import * as UserServices from "../../../services/UserServices";
import * as GeneralServices from "../../../services/GeneralServices";
import PATHS from "../../../constants/paths";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { useTranslation } from "react-i18next";
import { ROLE_TECHNICAL } from "../../../constants";

const AuthConfirmContainer = ({ temporalToken }) => {
  const user = useSelector(getAuthUserSelector);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (temporalToken) {
      try {
        GeneralServices.getItemLoginTemp(temporalToken).then((result) => {
          if (!result) {
            const okAction = () => {
              window.location.href = `${process.env.REACT_APP_LOGIN_URI}`;
            };

            ShowAlertDialog(
              t(`errorLogin`),
              t(`errorLoginText`),
              `error`,
              false,
              t(`OK`),
              false,
              okAction
            );
          }
        });
      } catch (error) {}
    }
  }, [temporalToken]);

  useEffect(() => {
    if (user) {
      UserServices.profile().then((result) => {
        if (result && result.roles) {
          if (result.roles.includes(ROLE_TECHNICAL)) {
            navigate(PATHS.MY_WORKING_PART_LIST);
          } else {
            navigate(PATHS.HOME);
          }
        }
      });
    }
  }, [user, navigate]);

  return <>Validando</>;
};

export default AuthConfirmContainer;
